/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsSaasAccount {
    getFixupPrototypeFunction() { return FilterOptionsSaasAccount.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsSaasAccount>): FilterOptionsSaasAccount {
        let obj = Object.assign(new FilterOptionsSaasAccount(), model);
        FilterOptionsSaasAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsSaasAccount>): FilterOptionsSaasAccount {
        if (!model) return null;
        return FilterOptionsSaasAccount.newInstance(<FilterOptionsSaasAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsSaasAccount) {
        if (!obj) return;

        models.FilterOptionsSaasAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsSaasAccount): boolean {
        Object.setPrototypeOf(obj, FilterOptionsSaasAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Indicates the status of the cloud account in corestack
     */
    status: models.ServiceAccountStatus;

    /**
     * ID of the Saas account
     */
    saas_account_id: string;

    /**
     * Name of the Saas account
     */
    saas_account_name: string;

    /**
     * Scope of the Saas account
     */
    scope: models.ServiceAccountScope;

    /**
     * Currency for the SaaS account
     */
    currency: models.Currency;

}
